module.exports = __webpack_public_path__ + "img/12.9.TU.c333bdc1.png";